(function(){
  if (window.__voroChips) return; window.__voroChips = true;
  var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function chipOf(t){ return t && t.closest ? t.closest('[data-vfy-chip]') : null; }
  function play(c){
    if (!c || c._t) return;
    c.classList.add('is-on');
    c._t = setTimeout(function(){ c.classList.remove('is-on'); setTimeout(function(){ c._t = null; }, 400); }, calm ? 1400 : 1900);
  }
  document.addEventListener('mouseover', function(e){ play(chipOf(e.target)); });
  document.addEventListener('focusin', function(e){ play(chipOf(e.target)); });
  document.addEventListener('click', function(e){ play(chipOf(e.target)); });
  var touch = window.matchMedia && matchMedia('(hover: none)').matches;
  if (!touch || !('IntersectionObserver' in window)) return;
  var seen = new WeakSet(), order = 0;
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ io.unobserve(e.target); var d = 350 + (order++ % 3) * 450; setTimeout(function(){ play(e.target); }, d); } });
  }, { threshold: .9 });
  function scan(){ document.querySelectorAll('[data-vfy-chip]').forEach(function(c){ if (!seen.has(c)){ seen.add(c); io.observe(c); } }); }
  scan();
  if ('MutationObserver' in window) new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
